import { useRequest } from 'ahooks'
import { Message } from '@/components/message'
import { t } from '@/i18n'
import {
  addSecurityDomain,
  deleteSecurityDomain,
  editSecurityDomain,
  getAgentList,
  getBoundAgentList,
  getBoundPhishingEmailList,
  getBoundSecurityTestEmailList,
  getBoundSiteList,
  getPhishingEmailList,
  getSecurityDomainList,
  getSecurityTestEmailList,
  getSiteList,
} from '@/api/security-domain/security-domain'

// 获取安全域列表
export const useGetSecurityDomainList = () => {
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(params => getSecurityDomainList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取安全域列表失败'))
    },
  })

  return [data?.data?.area || [], loading, run] as const
}

// 删除安全域
export const useDeleteSecurityDomain = () => {
  const { runAsync: run, loading } = useRequest(ids => deleteSecurityDomain(ids), {
    manual: true,
    onError: (err: any) => {
      Message.error(err?.msg || t('删除安全域失败'))
    },
  })

  return [run, loading] as const
}

// 获取绑定的钓鱼邮箱列表
export const useGetBoundFishingEmailList = () => {
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(params => getBoundPhishingEmailList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取绑定的钓鱼邮箱列表失败'))
    },
  })

  return [data?.data?.items || [], loading, run] as const
}

// 获取绑定的站点列表
export const useGetBoundSiteList = () => {
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(params => getBoundSiteList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取绑定的站点列表失败'))
    },
  })

  return [data?.data?.items || [], loading, run] as const
}

// 获取绑定的客户端列表
export const useGetBoundClientList = () => {
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(params => getBoundAgentList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取绑定的客户端列表失败'))
    },
  })

  return [data?.data?.items || [], loading, run] as const
}

// 获取绑定的验证邮箱列表
export const useGetBoundSecurityTestEmailList = () => {
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(params => getBoundSecurityTestEmailList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取绑定的验证邮箱列表失败'))
    },
  })

  return [data?.data?.items || [], loading, run] as const
}

// 获取钓鱼邮箱列表
export const useGetFishingEmailList = () => {
  const { data, runAsync: run } = useRequest(params => getPhishingEmailList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取钓鱼邮箱列表失败'))
    },
  })

  return [data?.data || {}, run] as const
}

// 获取站点列表
export const useGetSiteList = () => {
  const { data, runAsync: run } = useRequest(params => getSiteList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取站点列表失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取客户端列表
export const useGetClientList = () => {
  const { data, runAsync: run } = useRequest(params => getAgentList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取客户端列表失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}

// 获取验证邮箱列表
export const useGetSecurityTestEmailList = () => {
  const { data, runAsync: run } = useRequest(params => getSecurityTestEmailList(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('获取验证邮箱列表失败'))
    },
  })

  return [data?.data?.items || [], run] as const
}

// 新增安全域
export const useAddSecurityDomain = () => {
  const { runAsync: run, loading } = useRequest(params => addSecurityDomain(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('新增安全域失败'))
    },
  })

  return [run, loading] as const
}

// 编辑安全域
export const useEditSecurityDomain = () => {
  const { runAsync: run, loading } = useRequest(params => editSecurityDomain(params), {
    manual: true,
    onError(err: any) {
      Message.error(err.msg || t('编辑安全域失败'))
    },
  })

  return [run, loading] as const
}
